module.exports = __webpack_public_path__ + "static/img/energy-h5-1.a198975.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/energy-h5-1.png
// module id = 0mlH
// module chunks = 34